export var JobCategories;
(function (JobCategories) {
    JobCategories["OhElectric"] = "OH Electric";
    JobCategories["UgGas"] = "UG Gas";
    JobCategories["UgElectric"] = "UG Electric";
    JobCategories["CastIron"] = "Cast Iron Work";
    JobCategories["Overhead"] = "Overhead Work";
    JobCategories["General"] = "General";
})(JobCategories || (JobCategories = {}));
export var JobSummaryJobsTypes;
(function (JobSummaryJobsTypes) {
    JobSummaryJobsTypes["Maintenance"] = "maintenance";
    JobSummaryJobsTypes["NewJob"] = "newConstruction";
})(JobSummaryJobsTypes || (JobSummaryJobsTypes = {}));
//# sourceMappingURL=jobSummaryModel.js.map